import React, { Component } from 'react';
import { connect } from 'react-redux';
import classNames from 'classnames';
import {
  resolveThread,
  postComment,
  setActiveThread,
  setUnactiveThread,
} from 'actions/editor/commentary';
import Modal from 'components/shared/modal';
import CommentList from './CommentList';
import CommentForm from './CommentForm';
import ThreadOptions from './ThreadOptions';

class CommentThread extends Component {
  constructor(props) {
    super(props);
    this.state = { showConfirmation: false, error: false };
    this.showConfirmation = this.showConfirmation.bind(this);
    this.hideConfirmation = this.hideConfirmation.bind(this);
    this.handleClick = this.handleClick.bind(this);
    this.resolve = this.resolve.bind(this);
  }

  componentDidMount() {
    document.addEventListener('click', this.handleClick, true);
  }

  componentWillUnmount() {
    document.removeEventListener('click', this.handleClick, true);
  }

  handleClick({ target }) {
    const {
      props: { active, setActive, setUnactive },
      thread,
    } = this;
    const clickThread = thread.contains(target) || target === thread;
    if (clickThread && !active) {
      setActive();
    } else if (!clickThread && active) {
      setUnactive();
    }
  }

  showConfirmation() {
    this.setState({ showConfirmation: true });
  }

  hideConfirmation() {
    this.setState({ showConfirmation: false, error: false });
  }

  get resolveConfrimModal() {
    return {
      type: 'confirm',
      show: this.state.showConfirmation,
      title: t('lessons.editor.collaboration.resolve_modal.resolve_thread'),
      message: t(
        'lessons.editor.collaboration.resolve_modal.confirmation_message',
      ),
      confirmButtonText: t(
        'lessons.editor.collaboration.resolve_modal.confirm_button',
      ),
      cancelButtonText: t('common.cancel'),
      onConfirm: this.resolve,
      onCancel: this.hideConfirmation,
      dismissCallback: this.hideConfirmation,
    };
  }

  get resolveErrorModal() {
    return {
      ...this.resolveConfrimModal,
      type: 'confirm:error',
      confirmButtonText: t('lessons.editor.collaboration.try_again'),
      message: t('lessons.editor.collaboration.resolve_modal.error_message'),
    };
  }

  get resolveModal() {
    const { state, resolveConfrimModal, resolveErrorModal } = this;
    return state.error ? resolveErrorModal : resolveConfrimModal;
  }

  get threadOptions() {
    return [
      {
        children: t('lessons.editor.collaboration.resolve'),
        onClick: this.showConfirmation,
      },
    ];
  }

  resolve() {
    this.props.resolve().catch(error => {
      this.setState({ error: true });
    });
  }

  render() {
    const { comments, id, active, ...props } = this.props;
    const threadClassNames = classNames('CommentThread', {
      'CommentThread--active': active,
      'CommentThread--gray': comments.length > 1,
    });

    return (
      <div
        id={`thread-${id}`}
        className={threadClassNames}
        ref={node => {
          this.thread = node;
        }}
      >
        <Modal {...this.resolveModal} />
        <ThreadOptions options={this.threadOptions} />
        <CommentList comments={comments} />
        <CommentForm
          threadId={id}
          placeholder={`${t('lessons.editor.collaboration.reply')}...`}
          buttonText={t('lessons.editor.collaboration.reply')}
          postComment={props.postComment}
          useReplyButton
        />
      </div>
    );
  }
}

const mapStateToProps =
  () =>
  ({ editor }, { id }) => ({
    active: editor.commentary.activeThreads.has(id),
  });

const mapDispatchToProps = (dispatch, { id }) => ({
  resolve() {
    return dispatch(resolveThread(id));
  },
  postComment(body) {
    return dispatch(postComment(body, id));
  },
  setActive() {
    dispatch(setActiveThread(id));
  },
  setUnactive() {
    dispatch(setUnactiveThread(id));
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(CommentThread);
